export const ORGANIZATION_COPY = {
  mfaEnabledLabel: 'Enable MFA at login',
};
